import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular
export const createArtisanTagAction = (formData) => ({
  type: actions.CREATE_ARTISAN_TAG,
  payload: formData,
});

export const updateArtisanTagAction = (id, formData) => ({
  type: actions.UPDATE_ARTISAN_TAG,
  payload: {
    id,
    formData,
  },
});

// Plural
export const getArtisanTagsAction = (body) => ({
  type: actions.GET_ARTISAN_TAGS,
  payload : body
});

/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const createArtisanTagSuccessAction = (tag) => ({
  type: actions.CREATE_ARTISAN_TAG_SUCCESS,
  payload: tag,
});

export const updateArtisanTagSuccessAction = (tag) => ({
  type: actions.UPDATE_ARTISAN_TAG_SUCCESS,
  payload: tag,
});

// Plural
export const getArtisanTagsSuccessAction = (ArtisanTags) => ({
  type: actions.GET_ARTISAN_TAGS_SUCCESS,
  payload: ArtisanTags,
});

/**
 * Misc
 */
export const setArtisanTagsIsLoadingAction = (isLoading) => ({
  type: actions.SET_ARTISAN_TAGS_IS_LOADING,
  payload: isLoading,
});

export const setArtisanTagsCountAction = (count) => ({
  type: actions.SET_ARTISAN_TAGS_COUNT,
  payload: count,
});

export const setSearchValueAction = value => ({
  type : actions.SET_AT_SEARCH_VALUE,
  payload : value
})